export default __webpack_public_path__ + "static/media/Sate.dd083442.mp3";